import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SiteConfig } from 'src/app/models/site.config.models';
import { BrandingService } from 'src/app/services/branding.service';

@Component({
    selector: 'app-referee-thankyou',
    templateUrl: './referee-thankyou.component.html',
    styleUrls: ['./referee-thankyou.component.scss'],
    standalone: false
})
export class RefereeThankyouPage implements OnInit {

  public branding: SiteConfig|null = null;
  public applicantName: string = "this applicant";
  public refereeFirstName: string = "";

  constructor(
    brandingService: BrandingService,
    private router: Router
  ) {
    brandingService.branding$.subscribe(b => this.branding = b);
    let state = this.router.getCurrentNavigation()?.extras.state;
    if (state != null) {
      this.applicantName = state['applicantName'];
      this.refereeFirstName = state['refereeFirstName'];
    }
  }

  ngOnInit(): void {
  }

}
